import React from 'react';
import * as TotemActions from '../actions/TotemActions';
import TotemStore from '../stores/TotemStore';
import ArticleItemComponent from './ArticleItemComponent';
import { Line } from 'react-chartjs';

class ArticlesListComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      sortBy: '',
      sortAsc: false,
      articles: TotemActions.getArticles(true)
    };
  }

  componentWillMount() {
    TotemStore.on('ARTICLES_RECEIVED', this._onReceiveArticles.bind(this));
  }

  componentDidMount() {
  }

  _onReceiveArticles() {
    this.setState({
      articles: TotemStore.getArticles(),
      loading: false
    });
  }

  _handleSortBy(sort) {
    let sortAsc = this.state.sortBy === sort ? !this.state.sortAsc : true;
    this.setState({
      sortBy: sort,
      sortAsc: sortAsc
    });
  }

  _handleArticleDeleted() {
    //TotemActions.getArticles(true);
  }

  render() {
    let { articles } = this.state;
    let { sortBy } = this.state;
    let { sortAsc } = this.state;
    let items = [];

    if (sortBy != '') {
      articles.sort((a, b) => {
        if (sortAsc) {
          if (a[sortBy] < b[sortBy])
            return -1;
          if (a[sortBy] > b[sortBy])
            return 1;
          return 0;
        } else {
          if (a[sortBy] > b[sortBy])
            return -1;
          if (a[sortBy] < b[sortBy])
            return 1;
          return 0;
        }
      });
    }

    if (articles) {
      items = articles.map((article) => {
        return <ArticleItemComponent article={article} key={article.id} sortBy={this.state.sortBy} onArticleDeleted={this._handleArticleDeleted.bind(this)} />
      });
    }

    return (
      <table className="striped z-depth-2" >
        <thead>
          <tr>
            <th onClick={this._handleSortBy.bind(this, 'name')}>
              <div>
                <span>
                  Nombre del artículo
                </span>
                <i className={sortBy == 'name' ? sortAsc ? 'fa fa-chevron-up' : 'fa fa-chevron-down' : 'fa fa-chevron-up grey-text text-lighten-2'} />
              </div>
            </th>
            <th onClick={this._handleSortBy.bind(this, 'price')}>
              <div>
                <span>
                  Precio
                </span>
                <i className={sortBy == 'price' ? sortAsc ? 'fa fa-chevron-up' : 'fa fa-chevron-down' : 'fa fa-chevron-up grey-text text-lighten-2'} />
              </div>
            </th>
            <th onClick={this._handleSortBy.bind(this, 'views')}>
              <div>
                <span>
                  Vistas
                </span>
                <i className={sortBy == 'views' ? sortAsc ? 'fa fa-chevron-up' : 'fa fa-chevron-down' : 'fa fa-chevron-up grey-text text-lighten-2'} />
              </div>
            </th>
            <th className="hide-on-med-and-down" onClick={this._handleSortBy.bind(this, 'clicks')}>
              <div>
                <span>
                  Clicks en comprar
                </span>
                <i className={sortBy == 'clicks' ? sortAsc ? 'fa fa-chevron-up' : 'fa fa-chevron-down' : 'fa fa-chevron-up grey-text text-lighten-2'} />
              </div>
            </th>
            <th className="hide-on-med-and-down" onClick={this._handleSortBy.bind(this, 'attendant')}>
              <div>
                <span>
                  Llamado a empleado
                </span>
                <i className={sortBy == 'attendant' ? sortAsc ? 'fa fa-chevron-up' : 'fa fa-chevron-down' : 'fa fa-chevron-up grey-text text-lighten-2'} />
              </div>
            </th>
            <th className="hide-on-med-and-down" onClick={this._handleSortBy.bind(this, 'brandId')}>
              <div>
                <span>
                  Sucursal
                </span>
                <i className={sortBy == 'brandId' ? sortAsc ? 'fa fa-chevron-up' : 'fa fa-chevron-down' : 'fa fa-chevron-up grey-text text-lighten-2'} />
              </div>
            </th>
            <th>
              <div>
                <span>
                  Acciones
                </span>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          {items}
        </tbody>
      </table >
    );
  }
}

export default ArticlesListComponent;


// WEBPACK FOOTER //
// ./src/components/ArticlesListComponent.js